import React from 'react';

import styles from './kanban-card-action.module.scss';
interface KanbanCardActionProps {
  icon: React.ReactElement;
  onClick: (e: React.MouseEvent) => void;
  text?: string;
  /** Native tooltip, for actions whose icon alone is ambiguous (e.g. start vs. due date). */
  title?: string;
}

export const KanbanCardAction: React.FC<KanbanCardActionProps> = ({
  icon,
  onClick,
  text,
  title,
}) => (
  <div className={styles['container']} onClick={onClick} title={title}>
    {icon}
    {text && <span className="caption">{text}</span>}
  </div>
);
